// @flow
import { selectPricingInfos } from '@gandi/billing';
import { createResource } from '@gandi/resource/redux';
import type { Resource, FetchResponse } from '@gandi/resource/redux';

import { selectSetupOwner } from 'src/Cart/Setup/modules/selectors';

import type { Dispatch, ResourceThunkAction, GetState } from '../../types';

export const documentResource: Resource<> = createResource('document');
export const resource: Resource<> = createResource('tmch');
export const jurisdictionsResource: Resource<> =
  createResource('jurisdictions');
export const smdResource: Resource<> = createResource('smd');

export type PostDocumentsAction<R> = (
  file: FilePropertyBag,
  label: string,
) => R;
export type FetchPricesAction<R> = () => R;
export type FetchJurisdictionsAction<R> = () => R;
export type FetchSMDEntries<R> = () => R;
export type FetchSMD<R> = (smdId: string) => R;

export const fetchSmdEntries: FetchSMDEntries<ResourceThunkAction> =
  () => (dispatch: Dispatch, getState: GetState) => {
    const setupOwner = selectSetupOwner(getState());

    return dispatch(
      smdResource.fetch(`/tmch/organizations/${setupOwner}/smd`, {
        label: setupOwner,
        // $FlowFixMe[incompatible-call]
        not200: (error: FetchResponse<>) => Promise.reject(error),
      }),
    );
  };

export const fetchSmd: FetchSMD<ResourceThunkAction> =
  (smdId: string) => (dispatch: Dispatch, getState: GetState) => {
    const setupOwner = selectSetupOwner(getState());

    return dispatch(
      smdResource.fetchOne(`/tmch/organizations/${setupOwner}/smd/${smdId}`, {
        label: `${setupOwner} - ${smdId}`,
        headers: { Accept: 'text/plain', 'Content-Type': 'text/plain' },
        // $FlowFixMe[incompatible-call]
        not200: (error: FetchResponse<>) => Promise.reject(error),
      }),
    );
  };

export const uploadDocuments: PostDocumentsAction<ResourceThunkAction> =
  (formData, label) => (dispatch: Dispatch) =>
    dispatch(
      documentResource.post('/tmch/documents', formData, {
        label,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        on200: (response: FetchResponse<>) => Promise.resolve(response),
        // $FlowFixMe[incompatible-call]
        not20X: (error: FetchResponse<>) => Promise.reject(error),
      }),
    );

export const fetchPrices: FetchPricesAction<ResourceThunkAction> =
  () => (dispatch: Dispatch, getState: GetState) => {
    const { country, currency, grid } = selectPricingInfos(getState());

    return dispatch(
      resource.fetch('/tmch-anonymous/prices', {
        params: { country, currency, grid },
        on200: (response: FetchResponse<>) => Promise.resolve(response),
        // $FlowFixMe[incompatible-call]
        not200: (error: FetchResponse<>) => Promise.reject(error),
      }),
    );
  };

export const fetchJurisdictions: FetchJurisdictionsAction<
  ResourceThunkAction,
> = () => dispatch =>
  dispatch(
    jurisdictionsResource.fetch('/address2/tmch/jurisdictions', {
      on200: (response: FetchResponse<>) => Promise.resolve(response),
      // $FlowFixMe[incompatible-call]
      not200: (response: FetchResponse<>) => Promise.reject(response),
    }),
  );
